import { throttle } from "lodash";
import { useCallback, useEffect, useRef } from "react";

export const useThrottle = (cb, delay = 250) => {
    const options = { leading: true, trailing: true };
    const cbRef = useRef(cb);

    useEffect(() => {
        cbRef.current = cb;
    });

    return useCallback(
        throttle((...args) => cbRef.current(...args), delay, options),
        []
    );
};
